import * as Utils from "./utils";

export function init() {
    // Toggle Answers
    const questions = document.querySelectorAll(".js-faq-question");

    questions.forEach((question) => {
        question.addEventListener("click", (e) => {
            const container = question.closest(".js-faq"),
                answer = container.querySelector(".js-faq-answer");

            // Toggle icon
            if (container.classList.contains("open")) {
                container.classList.remove("open");
                Utils.slideUp(answer, 500);
            } else {
                container.classList.add("open");
                Utils.slideDown(answer, 500);
            }
        });
    });

    // Scroll to category on click
    const categories = document.querySelectorAll(".js-faq-category");

    categories.forEach((category) => {
        category.addEventListener("click", (e) => {
            // Find matching category section and smooth scroll to it
            const section = document.querySelector(
                `.js-faq-category-section[data-categoryid='${category.dataset.categoryid}']`
            );

            if (section) {
                window.scroll({
                    top: section.offsetTop - 50,
                    left: 0,
                    behavior: "smooth",
                });
            }
        });
    });

    const url = new URL(window.location.href),
        pathSegments = url.pathname.split("/");

    // If no 3rd segment (index = 3) do nothing
    if (pathSegments[3]) {
        // Auto-scroll and open FAQ from URL
        const urlQuestion = document.querySelector(
            `.js-faq[data-slug="${pathSegments[3]}"]`
        );

        if (urlQuestion) {
            urlQuestion.querySelector(".js-faq-question").click();

            setTimeout(() => {
                urlQuestion.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start",
                });
            }, 500); // Wait for answer to have opened before scrolling
        } else {
            // Check for category to scroll to
            const urlCategory = document.querySelector(
                `.js-faq-category-section[data-categoryslug="${pathSegments[3]}"]`
            );

            if (urlCategory) {
                urlCategory.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start",
                });
            }
        }
    }
}
